/**
 * @generated SignedSource<<48b52a9b5c37f2cd0552d9e614e149e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateSlackUserVerificationKeyInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateSlackUserVerificationKeyMutation$variables = {
  input: CreateSlackUserVerificationKeyInput;
};
export type CreateSlackUserVerificationKeyMutation$data = {
  readonly createSlackUserVerificationKey: {
    readonly key: string | null;
  } | null;
};
export type CreateSlackUserVerificationKeyMutation = {
  variables: CreateSlackUserVerificationKeyMutation$variables;
  response: CreateSlackUserVerificationKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSlackUserVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createSlackUserVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSlackUserVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateSlackUserVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ea1d027abcc2e7e77ffa302218d5c79a",
    "id": null,
    "metadata": {},
    "name": "CreateSlackUserVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSlackUserVerificationKeyMutation(\n  $input: CreateSlackUserVerificationKeyInput!\n) {\n  createSlackUserVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();

(node as any).hash = "79fbb6831e204c00aa13ba4a6010a93a";

export default node;
